import { type IConfig } from '@cian/config/shared';
import {
  DEFAULT_TIMEOUT_MS,
  REGION_FILTER_RS_KEY,
  TIMEOUT_RS_KEY,
  isDynamicCalltrackingEnabled,
  requestDynamicPhone,
  type IRegionFilter,
  type IOfferGeoLike,
  type IRequestDynamicPhoneDeps,
  type IRequestDynamicPhoneParams,
  type TDynamicPhoneResult,
} from '@cian/frontend-offer-dynamic-calltracking';
import { type IHttpApi } from '@cian/http-api';
import { type ILogger } from '@cian/logger';

import { type IPhone } from '../types/offer';

/** Ключа offerDynamicCalltracking.regionFilter в RS нет — динКТ выключен, точка работает по-старому */
export function getIsOfferDynamicCalltrackingEnabled(config: IConfig, geo: IOfferGeoLike | null | undefined): boolean {
  return isDynamicCalltrackingEnabled({
    regionFilter: config.get<IRegionFilter>(REGION_FILTER_RS_KEY),
    geo,
  });
}

interface IRequestOfferDynamicPhoneDeps {
  config: IConfig;
  httpApi: IHttpApi;
  logger: ILogger;
}

export function requestOfferDynamicPhone(
  params: IRequestDynamicPhoneParams,
  { config, httpApi, logger }: IRequestOfferDynamicPhoneDeps,
): Promise<TDynamicPhoneResult | null> {
  const deps: IRequestDynamicPhoneDeps = {
    httpApi,
    logger,
    timeoutMs: config.get<number>(TIMEOUT_RS_KEY) ?? DEFAULT_TIMEOUT_MS,
  };

  return requestDynamicPhone(params, deps);
}

/** КТ отдаёт номер строкой (`+7…`/`7…`/`8…`), вёрстка ждёт IPhone `{countryCode, number}` */
export function mapCalltrackingPhoneToIPhone(phone: string): IPhone {
  const digits = phone.replace(/\D/g, '');

  return { countryCode: '+7', number: digits.slice(-10) };
}
